module.exports = __webpack_public_path__ + "img/Kibe49.9b30e764.jpg";